import { LanguageCode } from '@digilize/shared/definitions/src';

export const getTranslation = <T extends { language: string }>(translations: T[], key: LanguageCode): T | null => {
  if (translations.some((el) => el.language === key)) {
    return translations.find((el) => el.language === key);
  } else {
    return null;
  }
};
